<template>
  <ContainerWrapper>
    <OffersList
      v-if="cptdDisplayAffiliates"
      title="Crédito no cartão de crédito"
    >
      <HCredOfferCardContainer v-if="cptdDisplayHCred" key="HCRED" />
      <CronosOfferCardContainer v-if="cptdDisplayCronos" key="CRONOS" />
    </OffersList>
  </ContainerWrapper>
</template>
<script>
import { mapGetters } from 'vuex'
import { checkAge, isDateGreaterThan, localDate } from '@/helpers/date'
import OffersList from '@/components/appForm/loanResults/OffersList.vue'
import ContainerWrapper from '@/components/ui/newComponents/ContainerWrapper.vue'
import HCredOfferCardContainer from '@/containers/loans/credit-card-equity/offer/affiliates/hcred/HCredOfferCardContainer.vue'
import { Partner } from '@/data/common'
import CronosOfferCardContainer from '~/containers/loans/credit-card-equity/offer/affiliates/cronos/CronosOfferCardContainer.vue'
import { abTest } from '~/helpers/abTest'
import { isExtendedBusinessHours } from '~/helpers/time'
export default {
  name: 'CreditCardEquityOffersListContainer',
  components: {
    CronosOfferCardContainer,
    HCredOfferCardContainer,
    ContainerWrapper,
    OffersList,
  },
  data() {
    return {
      hideHCred:
        sessionStorage.getItem('jb.state.affiliates.hcred.hide-offer-card') ===
        'true',
      hideCronos:
        sessionStorage.getItem('jb.state.affiliates.cronos.hide-offer-card') ===
        'true',
    }
  },
  computed: {
    ...mapGetters({
      personaData: 'user/persona/personaData',
      gtAllProposedNoCollateralOffers:
        'products/loans/no-collateral/no-collateral/gtAllProposedNoCollateralOffers',
      gtNoCollateralLatestSimulationRequest:
        'products/loans/no-collateral/no-collateral/gtNoCollateralLatestSimulationRequest',
    }),
    cptdIsRejectedInNoCollateral() {
      return (
        this.gtAllProposedNoCollateralOffers.length === 0 &&
        this.gtNoCollateralLatestSimulationRequest?.created &&
        isDateGreaterThan(
          localDate(this.gtNoCollateralLatestSimulationRequest?.created),
          new Date(Date.now() - 24 * 60 * 60 * 1000 * 30),
        )
      )
    },
    cptdPreConditions() {
      return this.cptdIsRejectedInNoCollateral
    },
    cptdDisplayAffiliates() {
      return (
        this.cptdPreConditions &&
        (this.cptdDisplayHCred || this.cptdDisplayCronos)
      )
    },
    cptdDisplayHCred() {
      const enabled = false
      if (!enabled) return false
      if (
        this.gtAllProposedNoCollateralOffers?.length === 1 &&
        this.gtAllProposedNoCollateralOffers?.find(
          (o) => o.partner === Partner.SIMPLIC,
        )
      ) {
        return false
      }
      return (
        !this.hideHCred && checkAge(19, 84, this.personaData?.info?.birth_date)
      )
    },
    cptdDisplayCronos() {
      const enabled = false
      return (
        enabled &&
        !this.hideCronos &&
        abTest(['0', '1', '2', '3', '4']) === 'A' &&
        isExtendedBusinessHours()
      )
    },
  },
}
</script>
<style lang="scss"></style>
